import {useContext} from 'react';

import {AiUsageContext} from 'src/modules/ai/usage/context';

export const useAiUsage = (changeRequestId: number) => {
    const context = useContext(AiUsageContext);

    if (!context) {
        throw new Error('Context does not exist');
    }

    return {
        setAiUsed: () => context.setAiUsed(changeRequestId),
        cleanAiUsed: () => context.cleanAiUsed(changeRequestId),
        checkFeedbackModal: () => context.checkFeedbackModal(changeRequestId),
    };
};
